import React, { useEffect, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
// import { Link, useHistory } from "react-router-dom";
import { NetworkAxios, OnboardingAxios } from "../../API";
import authSlice from "../../store/auth/authSlice";
import ProfileForm from "../profileForm/profileForm";
// import Moment from "react-moment";
// import ReadMore from "../../shared/commonComponents/ReadMore";
// import Avatar from "../commonComponents/Avatar";
import ProfileConnection from "./ProfileConnection";

const Profile = () => {
  const dispatch = useDispatch();
  const couponsRef = React.createRef();
  // const history = useHistory();

  const profileConfig = useSelector((state) => state.auth.profileConfig);
  const loggedInUser = useSelector((state) => state.auth.loggedInUser);
  const updateProfileImage = useSelector((state) => state.auth.updateProfileImage);

  const [aboutMePanelEdit, setAboutMePanelEdit] = useState(false);
  const [teamAccordOpen, setTeamAccordOpen] = useState(false);

  // const [couponTab, setCouponTab] = useState("Received");

  const [profileData, setProfileData] = useState(null);
  const [teamMembers, setTeamMembers] = useState([]);

  {/*TODO-change-04.09.2024 */ }
  // const [myConnections, setMyConnections] = useState([]);
  {/*TODO-change-04.09.2024 */ }

  useEffect(() => {
    console.log(couponsRef.current);
    if (profileConfig.showProfile === true) {
      // getMyCoupons(profileConfig.offeringUserId);
      profileConfig.scrollToCoupon &&
        couponsRef.current &&
        couponsRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [profileConfig.showProfile]);

  useEffect(() => {
    if (profileConfig && profileConfig.userId) {
      let profileOfferingId = 0;
      if (profileConfig.offeringId == 0) {
        profileOfferingId = loggedInUser.offeringId;
      }
      else {
        profileOfferingId = profileConfig.offeringId;
      }
      OnboardingAxios.get(
        "UserProfile/getuserprofile/" +
        profileConfig.userId +
        "/" +
        profileOfferingId
      )
        .then(function (response) {
          setProfileData(response.data);
          dispatch(authSlice.actions.setUserProfileData(response.data));
          // getMyCoupons(profileConfig.offeringUserId);
        })
        .catch(function (error) {
          console.log("error: " + error);
        });
    }

    if (profileConfig && profileConfig.offeringUserId) {
      OnboardingAxios.get(
        "OfferingUsers/getmyteamconnections/" + profileConfig.offeringUserId
      ).then(function (response) {
        let data = response.data;
        setTeamMembers(data);
      });
      {/*TODO-change-04.09.2024 */ }
      // NetworkAxios.get(
      //   "Connection/getmyconnections/" + profileConfig.offeringUserId
      // ).then(function (response) {
      //   let data = response.data;
      //   setMyConnections(data);
      // });
      {/*TODO-change-04.09.2024 */ }

    }
  }, [profileConfig.showProfile,
  profileConfig.userId,
  loggedInUser.offeringId,
  profileConfig.refreshProfile,
    updateProfileImage]);

  // const redirectToSearch = () => {
  //   dispatch(authSlice.actions.hideProfile());
  //   history.push({
  //     pathname: "/connections",
  //     state: { tab: "Search" },
  //   });
  // };

  // const [myCoupons, setMyCoupons] = useState([]);
  // const [givenCoupons, setGivenCoupons] = useState([]);
  // const getMyCoupons = (id) => {
  //   setMyCoupons([]);
  //   OnboardingAxios.get("OfferingUserCoupon/getmycoupons/" + id).then(function (
  //     response
  //   ) {
  //     let data = response.data;
  //     if (data) setMyCoupons(data);
  //   });

  //   OnboardingAxios.get("OfferingUserCoupon/getgivencoupons/" + id).then(
  //     function (response) {
  //       setGivenCoupons([]);
  //       let data = response.data;
  //       if (data) setGivenCoupons(data);
  //     }
  //   );
  // };

  const backToHome = () => {
    if (profileConfig.profileStack.length > 1) {
      dispatch(
        authSlice.actions.setProfileData({
          userId:
            profileConfig.profileStack[profileConfig.profileStack.length - 2][
            "userId"
            ],
          offeringUserId:
            profileConfig.profileStack[profileConfig.profileStack.length - 2][
            "offeringUserId"
            ],
        })
      );
      dispatch(authSlice.actions.UpdateProfileStack());
      dispatch(authSlice.actions.showProfile());
    } else {
      dispatch(authSlice.actions.hideProfile());
    }
  };

  // const openProfile = (userId, offeringUserId) => {
  //   dispatch(
  //     authSlice.actions.setProfileData({
  //       userId: userId,
  //       offeringUserId: offeringUserId,
  //     })
  //   );
  //   dispatch(
  //     authSlice.actions.setProfileStack({
  //       userId: userId,
  //       offeringUserId: offeringUserId,
  //     })
  //   );
  //   dispatch(authSlice.actions.setProfileLoader({ showLoader: true }));
  //   dispatch(authSlice.actions.showProfile());
  //   setTimeout(function () {
  //     dispatch(authSlice.actions.setProfileLoader({ showLoader: false }));
  //   }, 2000);
  // };

  return (
    <>
      {profileConfig.showProfileForm && (
        <ProfileForm showArrow={true}></ProfileForm>
      )}

      <Modal
        show={profileConfig && profileConfig.showProfile}
        backdrop="static"
        fullscreen={true}
        onHide={() => {
          dispatch(authSlice.actions.hideProfile());
        }}
        keyboard={false}
        className="profile-modal"
      >
        <Modal.Header>
          <div className="branding">
            <div className="logo-image"> </div>
            <div className="logo-text"></div>
            <div className="branding-glow"></div>
          </div>
          <div
            className="modal-close-btn"
            onClick={() => {
              dispatch(authSlice.actions.hideProfile());
            }}
          ></div>
        </Modal.Header>
        <Modal.Body>
          {profileConfig.showLoader && (
            <div className="loader-div">
              {/* <div><img src={loader}/></div> */}
              <div>Loading Profile Info...</div>
            </div>
          )}
          {!profileConfig.showLoader && (
            <div>
              <Row className="m-0">
                <div className="profile-page-header ">
                  <div className="back-icon"></div>
                  <span
                    className="back-text"
                    onClick={() => {
                      backToHome();
                    }}
                  >
                    Back
                  </span>
                </div>
              </Row>
              {profileData && (
                <Row>
                  <Col md={3} className="profileLeftPanel">
                    <div className="profile-left-div">
                      <div className={profileData.userProfile.roleId == 5 ? "profile-img-outline coach" : "profile-img-outline"}>
                        <div className="profile-frame-border">
                          <div className="profile-frame">
                            {profileData.userProfile.profileImage &&
                              profileData.userProfile.profileImage !== "NA" &&
                              <img className="profile-img" src={profileData.userProfile.profileImage} alt="" />
                            }
                            {(!profileData.userProfile.profileImage ||
                              profileData.userProfile.profileImage === "NA") && (
                                <div className="profile-text">
                                  <span>
                                    {profileData.userProfile.firstName[0].toUpperCase() +
                                      "" +
                                      profileData.userProfile.lastName[0].toUpperCase()}
                                  </span>
                                </div>
                              )}
                          </div>
                        </div>
                        {profileData.userProfile.roleId != 5 &&
                          <div className={profileData.userProfile.currentLevel ? "p-badge " + profileData.userProfile.currentLevel : "p-badge "} />
                        }
                      </div>

                      <div className="profile-user-name mb-2">
                        {profileData.userProfile.firstName}{" "}
                        {profileData.userProfile.lastName}
                      </div>
                      {profileData.userProfile.roleId != 5 && (
                        <div className="profile-level-points profile-border-bottom">
                          <div className="profile-level">
                            <span>Level</span>
                            <span>{profileData.userProfile.currentLevel}</span>
                          </div>
                          <div className="profile-square"></div>
                          <div className="profile-points">
                            <span></span>
                            <span>{profileData.userProfile.totalPoints}</span>
                          </div>
                        </div>
                      )}
                      <div className="profile-initial-details">
                        <div className="industry">
                          <span></span>
                          <span>{profileData.userProfile.industry}</span>
                        </div>
                        <div className="cbo">
                          <span></span>

                          <span>{profileData.userProfile.jobLevel}</span>
                        </div>
                        <div className="email">
                          <span></span>
                          <span>{profileData.userProfile.email}</span>
                        </div>
                        <div className="location">
                          <span></span>
                          <span>{profileData.userProfile.location}</span>
                        </div>
                      </div>
                      {loggedInUser.userId == profileData.userProfile.userId && <div
                        className="editDetails"
                        onClick={() => {
                          dispatch(authSlice.actions.showProfileForm(1));
                        }}
                      >
                        Edit Details
                      </div>}
                      {/* <div className="editDetails">
                                    Edit Details
                                </div> */}
                    </div>
                  </Col>
                  <Col md={6} className="profileMiddlePanel">
                    <div className="profile-about-me">
                      <div className="profile-header profile-border-bottom">
                        <span>About me</span>
                        {/* <span ></span> */}
                        {loggedInUser.userId == profileData.userProfile.userId && <span
                          onClick={() => {
                            dispatch(authSlice.actions.showProfileForm(2));
                          }}
                        ></span>}
                      </div>
                      <div className="profile-details-body">
                        {profileData &&
                          profileData.userProfileMetaData.length > 0 &&
                          profileData.userProfileMetaData
                            .filter((x) => x.category == "About me")
                            .map((item, index) => {
                              return (
                                <Row className="mt-3" key={"r" + index}>
                                  <Col md={1} style={{ width: "40px" }}>
                                    <span className="bullets"></span>
                                  </Col>
                                  <Col md={5}>
                                    <span className="bulletLabel">
                                      {item.value}
                                    </span>
                                  </Col>
                                  <Col md={6}>
                                    {!aboutMePanelEdit && (
                                      <div className="profile-desc">
                                        <span className="pe-2">:</span>
                                        {item.answer
                                          ? item.answer.replace(/,/g, ", ")
                                          : ""}
                                      </div>
                                    )}
                                    {aboutMePanelEdit && (
                                      <div className="aboutme-textarea">
                                        <span className="pe-5">:</span>
                                        <textarea></textarea>
                                      </div>
                                    )}
                                  </Col>
                                </Row>
                              );
                            })}
                      </div>
                    </div>
                    <div className="profile-communities-of-interest">
                      <div className="profile-header profile-border-bottom">
                        <span>Communities of Interest</span>
                        {/* <span></span> */}
                        {loggedInUser.userId == profileData.userProfile.userId && <span
                          onClick={() => {
                            dispatch(authSlice.actions.showProfileForm(3));
                          }}
                        ></span>}
                      </div>
                      <div className="profile-details-body">
                        {profileData &&
                          profileData.userProfileMetaData.length > 0 &&
                          profileData.userProfileMetaData
                            .filter(
                              (x) => x.category == "Communities of Interest"
                            )
                            .map((item, index) => {
                              return (
                                <Row className="mt-3" key={"r1" + index}>
                                  <Col md={1} style={{ width: "40px" }}>
                                    <span className="bullets"></span>
                                  </Col>
                                  <Col md={5}>
                                    <span className="bulletLabel">
                                      {item.value}
                                    </span>
                                  </Col>
                                  <Col md={6}>
                                    <div className="profile-desc">
                                      <span className="pe-2">:</span>
                                      {item.answer
                                        ? item.answer.replace(/,/g, ", ")
                                        : ""}
                                    </div>
                                  </Col>
                                </Row>
                              );
                            })}
                      </div>
                    </div>
                    {/* {profileData.userProfile.roleId != 5 && ( */}
                    {/*TODO-change-04.09.2024 */}
                    {/* <div className="profile-coupons mt-3">
                      <div className="profile-coupons-header">Tokens</div>
                      <div className="profile-coupons-body" ref={couponsRef}>
                        <Row className="mt-2">
                          <Col className="pr-0">
                            <div
                              className={`profile-coupons-child-header ${couponTab === "Received" ? "active" : ""
                                }`}
                              onClick={() => {
                                setCouponTab("Received");
                              }}
                            >
                              <div className="profile-coupons-child-header-label">
                                Received
                              </div>
                              {myCoupons && (
                                <div className="coupons-number">
                                  {myCoupons
                                    ? myCoupons.length.toLocaleString(
                                      "en-US",
                                      {
                                        minimumIntegerDigits: 2,
                                        useGrouping: false,
                                      }
                                    )
                                    : "00"}
                                </div>
                              )}
                            </div>
                          </Col>
                          {profileData.userProfile.roleId != 5 && (
                            <Col md={6} className="pl-0 coupons-header-divider">
                              <div
                                className={`profile-coupons-child-header ${couponTab === "Given" ? "active" : ""
                                  }`}
                                onClick={() => {
                                  setCouponTab("Given");
                                }}
                              >
                                <div className="profile-coupons-child-header-label">
                                  Given
                                </div>
                                {givenCoupons && (
                                  <div className="coupons-number">
                                    {givenCoupons
                                      ? givenCoupons.length.toLocaleString(
                                        "en-US",
                                        {
                                          minimumIntegerDigits: 2,
                                          useGrouping: false,
                                        }
                                      )
                                      : "00"}
                                  </div>
                                )}
                              </div>
                            </Col>
                          )}
                        </Row>
                        <Row>
                          {couponTab == "Received" && myCoupons && (
                            <Col md={12}>
                              {myCoupons.map((item) => {
                                return (
                                  <div
                                    key={item.id}
                                    className="coupon-receive-info p-3"
                                  >
                                    <div className="coupon-receive-info-desc">
                                      <ReadMore
                                        text={item.notes}
                                        name="See"
                                        maxLength={150}
                                      />
                                    </div>
                                    <div className="coupon-user-info mt-2">
                                      <Avatar {...item.userProfile} className="small" />
                                      <div className="coupon-user-name">
                                        <div className="mb-2">
                                          <span>
                                            {item.userProfile.firstName}{" "}
                                            {item.userProfile.lastName}
                                          </span>
                                          <span>{item.teamName}</span>
                                        </div>
                                        <div>
                                          <Moment
                                            format="MMM-YY"
                                            local={true}
                                          >
                                            {new Date(item.createdOn + "Z")}
                                          </Moment>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </Col>
                          )}
                          {profileData.userProfile.roleId != 5 && couponTab == "Given" && givenCoupons && (
                            <Col md={12}>
                              {givenCoupons.map((item) => {
                                return (
                                  <div
                                    key={item.id}
                                    className="coupon-receive-info p-3"
                                  >
                                    <div className="coupon-receive-info-desc">
                                      <ReadMore
                                        text={item.notes}
                                        name="See"
                                        maxLength={150}
                                      />
                                    </div>
                                    <div className="coupon-user-info mt-2">
                                      <Avatar {...item.userProfile} className="small" />
                                      <div className="coupon-user-name">
                                        <div className="mb-2">
                                          <span>
                                            {item.userProfile.firstName}{" "}
                                            {item.userProfile.lastName}
                                          </span>
                                          <span>{item.teamName}</span>
                                        </div>
                                        <div>
                                          <Moment
                                            format="MMM-YY"
                                            local={true}
                                          >
                                            {new Date(item.createdOn + "Z")}
                                          </Moment>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </Col>
                          )}

                        </Row>
                      </div>
                    </div> */}
                    {/*TODO-change-04.09.2024 */}

                    {/* )} */}
                  </Col>
                  <Col md={3}>
                    <div className="profile-team-connection">
                      <div className="profile-my-team">
                        <div
                          className="profile-my-team-header profile-border-bottom"
                          onClick={() => {
                            setTeamAccordOpen(!teamAccordOpen);
                          }}
                        >
                          <div className="team-label">My Team</div>
                          {teamAccordOpen && (
                            <div className="team-down-arrow"></div>
                          )}
                          {!teamAccordOpen && (
                            <div className="team-up-arrow"></div>
                          )}
                        </div>
                        {teamAccordOpen && (
                          <div className="profile-my-team-body">
                            <Row>
                              {teamMembers &&
                                teamMembers.map((item, index) => {
                                  return (
                                    <Col md={4} key={"r3" + index}>
                                      <ProfileConnection  {...item} />
                                    </Col>
                                  );
                                })}
                            </Row>
                          </div>
                        )}
                      </div>
                      {/*TODO-change-04.09.2024 */}

                      {/* <div className="profile-my-connection mt-3">
                        <div className="profile-my-connection-header profile-border-bottom">
                          <div className="connection-label">
                            <span>My Connections</span>
                            <span>
                              {myConnections.length.toLocaleString("en-US", {
                                minimumIntegerDigits: 2,
                                useGrouping: false,
                              })}
                            </span>
                          </div>
                          <button
                            className="d-flex align-items-center cdx-btn"
                            style={{ marginLeft: "auto" }}
                            onClick={redirectToSearch}
                          >
                            <div className="profile-search-icon"></div> Search
                          </button>
                        </div>
                        <div className="profile-my-connection-body">
                          <Row>
                            {myConnections &&
                              myConnections.map((item, index) => {
                                return (
                                  <Col md={4} key={"r4" + index}>
                                    <ProfileConnection  {...item} />
                                  </Col>
                                );
                              })}
                          </Row>
                        </div>
                      </div> */}
                      {/*TODO-change-04.09.2024 */}

                    </div>
                  </Col>
                </Row>
              )}
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Profile;
